import React, { useState } from 'react'
import * as Yup from "yup";
import { useAuth } from '../../contexts/AuthContext';
import { useDialog } from '../../contexts/DialogContext';
// import RenderSettlement from './RenderSettlement';
import RenderQuotation from './RenderQuotation';
import { Circle } from '../../components/Animation';
import { validateType } from '../../utils/constant';
import { requestAuth } from '../../components/services/RequestService';
import { toast } from 'react-toastify';
import FormDefault from '../../components/Forms/FormDefault';
import { Request } from '../../hooks/Request';
import RenderLiquidaciónProforma from './RenderLiquidaciónProforma';

const RenderProformOrQuotationWithForm = (props) => {
    const { user } = useAuth()
    const { procedure, onClose, isQuotation } = props
    const { openDialog } = useDialog();
    const [searchField] = useState("");
    const { data, loading } = Request({
        urlApi: "/dropdown/user/accountNumbers",
    });
    const { data: dataValProcs } = Request({
        urlApi: `/procedure/${procedure.id}/dataFields?fieldnames=proformaExcel`,
    });

    function handleProformOrQuotation(values) {
        openDialog(
            isQuotation ?
                <RenderQuotation {...props} accountNumber={values.account} />
                :
                <RenderLiquidaciónProforma {...props} accountNumber={values.account} />
        );
    }

    function handleAccount() {
        const list = data.map((item) =>
            item.accountNumber
                ? {
                    label: `${item.accountNumber} - ${item.name} ${item.fatherLastName}`,
                    value: item.accountNumber,
                }
                : null
        );
        return list.filter((n) => n);
    }

    if (!loading) {
        return <Circle />;
    }

    function dataIntialValues(list) {
        let aux = {};
        list?.forEach((element) => {
            aux = {
                ...aux,
                [element.name]:
                    (element.initial === "false" ? false : element.initial) || "",
            };
        });
        return aux;
    }

    function dataFields(list) {
        let aux = {};
        list?.forEach((element) => {
            aux = {
                ...aux,
                [element.name]: element.validate
                    ? validateType[element.type] || null
                    : null,
            };
        });
        return aux;
    }

    async function submitDataset(values, resetForm, btnSecondary, realValues) {
        if (realValues.proformaExcel instanceof File) {
            await requestAuth("post", "/dataset" + (props.isGeneral ? "?isGeneral=true" : ""), values)
                .then(async () => {
                    toast.success("Documento guardado correctamente!");
                    if (realValues.readDoc) {
                        await requestAuth("post", `/Tradecruz/procedure/${procedure.id}/readerXlsxProforma`, values)
                            .then(() => {
                                // reload();
                                toast.success("Lectura exitosa!");
                                onClose();
                                resetForm();
                                handleProformOrQuotation(realValues)
                            })
                            .catch(() => {
                                toast.error("Error en la lectura del documento!");
                            });

                    }
                    else {
                        onClose();
                        resetForm();
                        handleProformOrQuotation(realValues)
                    }
                    // onClose();
                    // resetForm();
                    // handleProform(values)
                })
                .catch(() => {
                    toast.error("Error en el envio");
                });
        }
        else {
            if (realValues.readDoc) {
                await requestAuth("post", `/Tradecruz/procedure/${procedure.id}/readerXlsxProforma`, values)
                    .then(() => {
                        // reload();
                        toast.success("Lectura exitosa!");
                        onClose();
                        resetForm();
                        handleProformOrQuotation(realValues)
                    })
                    .catch(() => {
                        toast.error("Error en la lectura del documento!");
                    });

            }
            else {
                onClose();
                resetForm();
                handleProformOrQuotation(realValues)
            }
        }
    }

    async function onSubmit(values, resetForm, fields) {
        const result = await Promise.all(
            fields.map(async (element) => {
                if (element.type === "file" || element.type === "fileRead") {
                    if (
                        (values[element.name] === "" || values[element.name] === null) &&
                        (element.initial === "" || element.initial === null)
                    ) {
                        return null;
                    } else if (
                        (values[element.name] !== "" && !element.initial) ||
                        (values[element.name] !== "" &&
                            values[element.name] !== element.initial)
                    ) {
                        let formData = new FormData();
                        formData.append("Name", element.name);
                        formData.append("File", values[element.name]);
                        formData.append("originalName", values[element.name].name);
                        formData.append("Status", "verified");
                        formData.append("ProcedureId", procedure.id);
                        const fileContents = await requestAuth(
                            "post",
                            "/files",
                            formData
                        ).then((res) => {
                            return {
                                Value: res.data.url,
                                ProcedureId: procedure.id,
                                FieldId: element.id,
                                FileId: res.data.id,
                            };
                        });
                        return fileContents;
                    } else {
                        return {
                            Value: element.initial,
                            ProcedureId: procedure.id,
                            FieldId: element.id,
                        };
                    }
                } else {
                    return {
                        Value:
                            values[element.name] || values[element.name] === 0
                                ? values[element.name]
                                : "",
                        ProcedureId: procedure.id,
                        FieldId: element.id,
                    };
                }
            })
        );
        await submitDataset(
            result.filter((n) => n),
            resetForm,
            values.btnSecondary,
            values,
        );
    }
    return (
        <>
            {/* {JSON.stringify(user)} */}
            <FormDefault
                fields={[
                    ...(
                        dataValProcs ? dataValProcs?.fieldList
                            .sort((a, b) => a.order - b.order)
                            .map((value, index) => ({
                                ...value,
                                id: procedure.id,
                                code: procedure.internCode,
                                fieldId: value.id,
                                // labelCustom: (
                                //   <>
                                //     <span className="font-bold text-green-600">
                                //       {index + 1}.
                                //     </span>{" "}
                                //     {value.label}
                                //   </>
                                // ),
                                name: value.name,
                                validate: value.validate,
                                lockEdition: value.lockEdition,
                                placeholder: "Complete el campo",
                                type: value.type === "fileRead" ? "file" : value.type,
                                typeInput: value.type === "fileRead" ? "file" : value.type,
                                initial: value.initial ? value.initial : null,
                                urlApi: value.url
                                    ? value.url.includes("/")
                                        ? value.url
                                        : `/Dropdown/${value.url}/options`
                                    : "",
                                urlApiGroup: value.urlGroup
                                    ? value.urlGroup.includes("/")
                                        ? value.urlGroup
                                        : `/Dropdown/${value.urlGroup}/options`
                                    : "",
                                urlInitial: value.url,
                                value: "name",
                                labelOption: "name",
                                aditionalClassName: value.label
                                    .toLowerCase()
                                    .includes(searchField)
                                    ? ""
                                    : "hidden overflow-hidden",
                                action: () => { },
                                // reload: handleReaload,
                                // step: step,
                            }))
                            :
                            []
                    ),
                    {
                        label: "Atención",
                        name: "account",
                        typeInput: "select",
                        options: handleAccount(),
                    },
                    {
                        label: "Leer el documento EXCEL",
                        name: "readDoc",
                        type: "checkbox",
                        options: handleAccount(),
                    },
                ]}
                initialValues={
                    {
                        ...dataIntialValues(dataValProcs?.fieldList ?? []),
                        account: user?.user?.accountNumber ?? '',
                        readDoc: true
                    }
                }
                validationSchema={Yup.object().shape(dataFields(dataValProcs?.fieldList))}

                onSubmit={async (values, resetForm) =>
                    await onSubmit(values, resetForm, dataValProcs?.fieldList)
                }
                fullData={data}
                buttonName={isQuotation ? "GENERAR COTIZACIÓN" : "GENERAR PROFORMA"}
            />
        </>
    );
}

export default RenderProformOrQuotationWithForm